import React from "react";
import "./Leadership.css";
import marieImage from "../assets/marie.jpeg";
import scottImage from "../assets/scott.jpeg";

export default function Leadership() {
  return (
    <section className="leadership" id="leadership">
      <div className="leadership__container">
        <header className="leadership__header">
          <h2 className="leadership__title">Our Leadership</h2>
        </header>

        {/* ===== Row 1: Marie ===== */}
        <div className="leaderRow">
          {/* Image - left */}
          <div className="leaderRow__imageWrap">
            <img
              src={marieImage}
              alt="Portrait of Marie Dudley-Kidwell"
              className="leaderRow__img"
            />
            <div className="leaderRow__imgOverlay" />
            <div className="leaderRow__float leaderRow__float--a" />
            <div className="leaderRow__float leaderRow__float--b" />
            <div className="leaderRow__float leaderRow__float--c" />
          </div>

          {/* Text - right */}
          <div className="leaderRow__textWrap">
            <article className="leader leader--marie">
              <header className="leader__head">
                <h3 className="leader__name">Marie Dudley-Kidwell</h3>
                <div className="leader__accent" />
                <p className="leader__role">Community Leader</p>
              </header>

              <div className="leader__bio leader__bio--justify">

                <p>
                  Marie leads with trust and integrity, is passionate about helping
                  others grow their businesses and develop professionally. Her
                  leadership style is inclusive and empowering,
                  encouraging all members to contribute, collaborate, and take
                  initiative.
                </p>
                <br></br>
                <p>
                  Marie believes in the power of networking, building trust and
                  integrity with authentic professional relationships, sparking
                  creativity and collaborative partnerships. She also supports the benefit of the
                  less fortunate in our community by leading a member-optional quarterly project for a selected community member in need.
                </p>
                <br></br>
                <p>
                  Marie has a large family and once she meets you, you become a
                  part of that family too.
                </p>
              </div>
            </article>
          </div>
        </div>

        <div className="leader__divider" />

        {/* ===== Row 2: Scott ===== */}
        <div className="leaderRow">
          {/* Image - left (now added for Scott too) */}
          <div className="leaderRow__imageWrap">
            <img
              src={scottImage}
              alt="Portrait of Scott Kidwell"
              className="leaderRow__img"
            />
            <div className="leaderRow__imgOverlay" />
            <div className="leaderRow__float leaderRow__float--a" />
            <div className="leaderRow__float leaderRow__float--b" />
            <div className="leaderRow__float leaderRow__float--c" />
          </div>

          {/* Text - right */}
          <div className="leaderRow__textWrap">
            <article className="leader">
              <header className="leader__head">
                <h3 className="leader__name">Scott Kidwell</h3>
                <div className="leader__accent" />
                <p className="leader__role">Project Foreman</p>
              </header>

              <p className="leader__bio">
                Scott Kidwell is a man of trust and integrity who will be leading community projects as our dedicated project foreman, and who fully supports
                his wife in her many endeavors.
              </p>
              <br></br>
              <p className="leader__bio">
                Scott loves being there for his wife and family, and helping
                others succeed and develop in their respective businesses.
              </p>
              <br></br>
              <p className="leader__bio">
                Scott will be a strong support to this group and his wife, and
                will be the project manager on any special projects that happen in
                the community and also at our meetings.
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
